export default __webpack_public_path__ + "icon-stumbler.ba2bd74e.png";